import { render, staticRenderFns } from "./_purgeTeamLog.vue?vue&type=template&id=ed3db348&scoped=true&lang=pug&"
import script from "./_purgeTeamLog.vue?vue&type=script&lang=js&"
export * from "./_purgeTeamLog.vue?vue&type=script&lang=js&"
import style0 from "./_purgeTeamLog.vue?vue&type=style&index=0&id=ed3db348&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed3db348",
  null
  
)

export default component.exports